import React from 'react';
import { Fragment } from 'react';

const SearchResults = ({
  searchResult,
  searchVal,
  noResult,
  isSearch
}) => {
  return (
    <Fragment>
      {searchResult && searchVal !== '' && (
        <div className="search-result">Search Results</div>
      )}
      {searchResult && searchVal !== '' && noResult && isSearch && (
        <div className="search-noresult">
          <p>
            Your search for <strong>{searchVal}</strong> did not match
            anything in our FAQ
          </p>
          <p>
            If you cannot find what you need, please try to{' '}
            <a href="/contact" style={{ color: '#128dff' }}>
              Contact Us
            </a>{' '}
            by filling out a form
          </p>
        </div>
      )}
    </Fragment>
  );
};

export default SearchResults;



// WEBPACK FOOTER //
// ./src/components/Static/NewGeneralFaq/SearchResults.js